import {
	START_FETCH_CONVERSATION_REPLIES,
	FETCH_CONVERSATION_REPLIES_SUCCESS,
	FETCH_CONVERSATION_REPLIES_FAILED,

	START_FETCH_NEXT_CONVERSATION_REPLIES,
	FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS,
	FETCH_NEXT_CONVERSATION_REPLIES_FAILED,

	START_CREATE_TEXT_CONVERSATION_REPLY,
	CREATE_TEXT_CONVERSATION_REPLY_SUCCESS,
	CREATE_TEXT_CONVERSATION_REPLY_FAILED,

	START_CREATE_FILE_CONVERSATION_REPLY,
	CREATE_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_FILE_CONVERSATION_REPLY_FAILED,

	START_CREATE_FORM_FILE_CONVERSATION_REPLY,
	CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED,

	START_SELECT_CONVERSATION_TAG,
	SELECT_CONVERSATION_TAG_SUCCESS,
	SELECT_CONVERSATION_TAG_FAILED,

	START_SELECT_CONVERSATION_QA_OPTION,
	SELECT_CONVERSATION_QA_OPTION_SUCCESS,
	SELECT_CONVERSATION_QA_OPTION_FAILED,

	START_CREATE_CONVERSATION_FORM_REPLY,
	CREATE_CONVERSATION_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_FORM_REPLY_FAILED,

	START_SEND_TYPEING_CONVERSATION_REPLY,
	SEND_TYPEING_CONVERSATION_REPLY_SUCCESS,

	APPEND_CONVERSATION_REPLIES,

	RECEIVE_CONVERSATION_REPLY,
	RECEIVE_UPDATED_CONVERSATION_REPLY,

	RESET_CONVERSATION_REPLY,

	START_RESET_CONVERSATION_SMART_REPLY,
	RESET_CONVERSATION_SMART_REPLY_SUCCESS,

	START_CONTACT_CS_CONVERSATION,
	CONTACT_CS_CONVERSATION_SUCCESS,
	CONTACT_CS_CONVERSATION_FAILED,

	START_CREATE_CONVERSATION_QA_FORM_REPLY,
	CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_QA_FORM_REPLY_FAILED,

	START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY,
	CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
	CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED,

	START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY,
	CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS,
	CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED,

	START_CREATE_QUICK_FORM_CONVERSATION_REPLY,
	CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS,
	CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED,
} from './action-types';

export function fetchConversationRepliesAction({ pointer, limit, order, sort } = {}) {
	return {
		type: START_FETCH_CONVERSATION_REPLIES,
		pointer,
		limit,
		order,
		sort,
	};
}

export function fetchConversationRepliesSuccessAction(conversationReplies, hasNext) {
	return {
		type: FETCH_CONVERSATION_REPLIES_SUCCESS,
		conversationReplies,
		hasNext,
	};
}

export function fetchConversationRepliesFailedAction(error, errorMessage) {
	return {
		type: FETCH_CONVERSATION_REPLIES_FAILED,
		error,
		errorMessage,
	};
}

export function fetchNextConversationRepliesAction({ pointer, limit, order, sort } = {}) {
	return {
		type: START_FETCH_NEXT_CONVERSATION_REPLIES,
		pointer,
		limit,
		order,
		sort,
	};
}

export function fetchNextConversationRepliesSuccessAction(conversationReplies, hasNext) {
	return {
		type: FETCH_NEXT_CONVERSATION_REPLIES_SUCCESS,
		conversationReplies,
		hasNext,
	};
}

export function fetchNextConversationRepliesFailedAction(error, errorMessage) {
	return {
		type: FETCH_NEXT_CONVERSATION_REPLIES_FAILED,
		error,
		errorMessage,
	};
}

export function createTextConversationReplyAction(message, quoteReplyId) {
	return {
		type: START_CREATE_TEXT_CONVERSATION_REPLY,
		message,
		quoteReplyId,
	};
}

export function createTextConversationReplySuccessAction(conversationReply) {
	return {
		type: CREATE_TEXT_CONVERSATION_REPLY_SUCCESS,
		conversationReply,
	};
}

export function createTextConversationReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_TEXT_CONVERSATION_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function createFileConversationReplyAction(type, file, quoteReplyId) {
	return {
		type: START_CREATE_FILE_CONVERSATION_REPLY,
		conversationType: type,
		file,
		quoteReplyId,
	};
}

export function createFileConversationReplySuccessAction(conversationReplyId) {
	return {
		type: CREATE_FILE_CONVERSATION_REPLY_SUCCESS,
		conversationReplyId,
	};
}

export function createFileConversationReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_FILE_CONVERSATION_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function createFormFileConversationReplyAction(data) {
	return {
		type: START_CREATE_FORM_FILE_CONVERSATION_REPLY,
		data,
	};
}

export function createFormFileConversationReplySuccessAction(conversationReplyId) {
	return {
		type: CREATE_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
		conversationReplyId,
	};
}

export function createFormFileConversationReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_FORM_FILE_CONVERSATION_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function selectConversationReplyTagAction(data) {
	return {
		type: START_SELECT_CONVERSATION_TAG,
		data,
	};
}

export function selectConversationReplyTagSuccessAction() {
	return {
		type: SELECT_CONVERSATION_TAG_SUCCESS,
	};
}

export function selectConversationReplyTagFailedAction(err = {}, errorMessage) {
	const { error } = err;

	return {
		type: SELECT_CONVERSATION_TAG_FAILED,
		error,
		errorMessage,
	};
}

export function selectConversationReplyQAOptionAction(conversationReplyId, qaNodeId) {
	return {
		type: START_SELECT_CONVERSATION_QA_OPTION,
		conversationReplyId,
		qaNodeId,
	};
}

export function selectConversationReplyQAOptionSuccessAction() {
	return {
		type: SELECT_CONVERSATION_QA_OPTION_SUCCESS,
	};
}

export function selectConversationReplyQAOptionFailedAction(error, errorMessage) {
	return {
		type: SELECT_CONVERSATION_QA_OPTION_FAILED,
		error,
		errorMessage,
	};
}

export function createConversationFormReplyAction(conversationReplyId, formReplies) {
	return {
		type: START_CREATE_CONVERSATION_FORM_REPLY,
		conversationReplyId,
		formReplies,
	};
}

export function createConversationFormReplySuccessAction(conversationReplies) {
	return {
		type: CREATE_CONVERSATION_FORM_REPLY_SUCCESS,
		conversationReplies,
	};
}

export function createConversationFormReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_CONVERSATION_FORM_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function sendTypingConversationReplyAction(message) {
	return {
		type: START_SEND_TYPEING_CONVERSATION_REPLY,
		message,
	};
}

export function sendTypingConversationReplySuccessAction() {
	return {
		type: SEND_TYPEING_CONVERSATION_REPLY_SUCCESS,
	};
}

export function appendConversationRepliesAction(conversationReplies) {
	return {
		type: APPEND_CONVERSATION_REPLIES,
		conversationReplies,
	};
}

export function receiveConversationReplyAction(conversationId, conversationReplies) {
	return {
		type: RECEIVE_CONVERSATION_REPLY,
		conversationId,
		conversationReplies,
	};
}

export function receiveUpdatedConversationReplyAction(updatedConversationReplies) {
	return {
		type: RECEIVE_UPDATED_CONVERSATION_REPLY,
		updatedConversationReplies,
	};
}

export function resetConversationReplyAction() {
	return {
		type: RESET_CONVERSATION_REPLY,
	};
}

export function resetConversationSmartReplyAction(conversationReplyId) {
	return {
		type: START_RESET_CONVERSATION_SMART_REPLY,
		conversationReplyId,
	};
}

export function resetConversationSmartReplySuccessAction() {
	return {
		type: RESET_CONVERSATION_SMART_REPLY_SUCCESS,
	};
}

export function contactCSConversationAction(data) {
	return {
		type: START_CONTACT_CS_CONVERSATION,
		data,
	};
}

export function contactCSConversationSuccessAction() {
	return {
		type: CONTACT_CS_CONVERSATION_SUCCESS,
	};
}

export function contactCSConversationFailedAction(err = {}, errorMessage) {
	const { error } = err;

	return {
		type: CONTACT_CS_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function createConversationQAFormReplyAction(data) {
	return {
		type: START_CREATE_CONVERSATION_QA_FORM_REPLY,
		data,
	};
}

export function createConversationQAFormReplySuccessAction(conversationReplies) {
	return {
		type: CREATE_CONVERSATION_QA_FORM_REPLY_SUCCESS,
		conversationReplies,
	};
}

export function createConversationQAFormReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_CONVERSATION_QA_FORM_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function createQAFormFileConversationReplyAction(conversationReplyId, file, options) {
	const { type, title } = options;

	return {
		type: START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY,
		conversationReplyId,
		file,
		options: {
			type,
			title,
		},
	};
}

export function createQAFormFileConversationReplySuccessAction(formFile, options) {
	const { conversationReplyId, title } = options;

	return {
		type: CREATE_QA_FORM_FILE_CONVERSATION_REPLY_SUCCESS,
		formFile,
		conversationReplyId,
		title,
	};
}

export function createQAFormFileConversationReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_QA_FORM_FILE_CONVERSATION_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function createConversationQAChargeFormReplyAction(conversationReplyId, chargeFormReply) {
	return {
		type: START_CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY,
		conversationReplyId,
		chargeFormReply,
	};
}

export function createConversationQAChargeFormReplySuccessAction(conversationReplies) {
	return {
		type: CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_SUCCESS,
		conversationReplies,
	};
}

export function createConversationQAChargeFormReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_CONVERSATION_QA_CHARGE_FORM_REPLY_FAILED,
		error,
		errorMessage,
	};
}

export function createQuickFormConversationReplyAction(formData) {
	return {
		type: START_CREATE_QUICK_FORM_CONVERSATION_REPLY,
		formData,
	};
}

export function createQuickFormConversationReplySuccessAction() {
	return {
		type: CREATE_QUICK_FORM_CONVERSATION_REPLY_SUCCESS,
	};
}

export function createQuickFormConversationReplyFailedAction(error, errorMessage) {
	return {
		type: CREATE_QUICK_FORM_CONVERSATION_REPLY_FAILED,
		error,
		errorMessage,
	};
}
